import { useMutation } from "@apollo/client/react";

import {
  type DocumentKindEnum,
  type DraftTemplateRoleEnum,
  ProjectDocumentAttachDocument,
} from "@app_schema";

import { track } from "@application/utilities/track";

// The passive document attach shared by every bucket that isn't records —
// Final Report, dictation, supporting. Record uploads deliberately don't come
// through here: they run the record-review workflow and fire
// `record_processing_started` instead. Null kind = supporting documents.
export const useProjectDocumentSave = (projectID: string) => {
  const [attach] = useMutation(ProjectDocumentAttachDocument);

  // `draftTemplateRole`: what a Word draft is for, when he already has a template.
  return async (
    blob: { signed_id: string },
    kind: DocumentKindEnum | null,
    draftTemplateRole?: DraftTemplateRoleEnum,
  ) => {
    // Don't await the refetch: a failed reload after a committed save would mark
    // the file "Upload failed", and re-dropping it creates a duplicate document.
    await attach({
      variables: {
        projectID,
        input: { fileID: blob.signed_id, kind, draftTemplateRole },
      },
      refetchQueries: ["DashboardProjectsDetails"],
    });

    track("document_uploaded", {
      project_id: projectID,
      kind: kind ?? "supporting",
      ...(draftTemplateRole && { draft_template_role: draftTemplateRole }),
    });
  };
};
